'use client'
import { jsx } from "react/jsx-runtime";
import { iconRegistry } from "@pcln/horizon-icons";
import { Suspense, lazy, memo } from "react";
import { cn } from "../../utils/index.js";
import { cdnIconVariants } from "../CdnIcon/CdnIcon.variants.js";
const lazyIconCache = new Map();
function getLazyIcon(name) {
    if (!lazyIconCache.has(name)) {
        const LazyIcon = /*#__PURE__*/ lazy(()=>{
            const icon = iconRegistry[name];
            if (!icon) throw new Error(`@pcln/horizon-icons//HorizonIcon: Icon ${name} not found`);
            return icon?.() ?? null;
        });
        lazyIconCache.set(name, LazyIcon);
    }
    return lazyIconCache.get(name);
}
const HorizonIcon = /*#__PURE__*/ memo(({ name, className, palette, shade, size, ...svgProps })=>{
    if (!name) return null;
    const IconComponent = getLazyIcon(name);
    const classes = cn(cdnIconVariants({
        palette,
        shade,
        size
    }), className);
    return /*#__PURE__*/ jsx("div", {
        className: classes,
        children: /*#__PURE__*/ jsx(Suspense, {
            fallback: /*#__PURE__*/ jsx("div", {
                className: "bg-neutral-8"
            }),
            children: /*#__PURE__*/ jsx(IconComponent, {
                ...svgProps
            })
        })
    });
});
export { HorizonIcon };
